export const displayErrors: { [x: string]: string } = {
  INVALID_TOKEN: 'The page has timed out.',
  LOGIN_FAIL: 'Your bank did not accept the username and password',
  ERROR:
    'An unexpected error has occurred and the Lumi team has been notified. Please try again, otherwise get in touch with your account representative',
};
